// Utilidades compartidas para armar links de WhatsApp (wa.me) desde el panel.

export function normalizeWhatsAppPhone(phone) {
  if (!phone) return "";
  const trimmed = phone.trim();
  const digits = trimmed.replace(/\D/g, "");
  if (trimmed.startsWith("+")) return digits;
  // Solo asumimos +1 (EEUU) cuando el numero tiene exactamente 10 digitos;
  // en cualquier otro caso lo dejamos como esta para no generar links rotos.
  if (digits.length === 10) return `1${digits}`;
  return digits;
}

export function buildWhatsAppLink(phone, message) {
  const normalized = normalizeWhatsAppPhone(phone);
  const text = encodeURIComponent(message || "");
  return `https://wa.me/${normalized}${text ? `?text=${text}` : ""}`;
}
